import { ExternalLink, AlertTriangle } from "lucide-react";

export const ExternalLinkDialog = ({ open, onClose, url, title, sourceName }) => {
  if (!open) return null;

  const handleContinue = () => {
    window.open(url, "_blank", "noopener,noreferrer");
    onClose();
  };

  const domain = (() => {
    try { return new URL(url).hostname.replace("www.", ""); } catch { return url; }
  })();

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="external-link-dialog">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-[#0A192F] border border-white/10 rounded-xl shadow-2xl max-w-md w-full p-6 animate-fade-in">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-lg bg-amber-500/10 flex items-center justify-center flex-shrink-0">
            <AlertTriangle className="w-5 h-5 text-amber-400" />
          </div>
          <div>
            <h3 className="font-headline text-base font-medium text-[#F8FAFC]">Leaving AI Know Board</h3>
            <p className="text-xs text-[#94A3B8]">You're about to visit an external platform</p>
          </div>
        </div>

        <div className="p-4 rounded-lg bg-white/[0.03] border border-white/[0.06] mb-4">
          <p className="text-sm text-[#F8FAFC] font-medium mb-1 line-clamp-2">{title}</p>
          <div className="flex items-center gap-2 mt-2">
            <ExternalLink className="w-3.5 h-3.5 text-[#14B8A6]" />
            <span className="text-xs text-[#14B8A6] truncate">{domain}</span>
          </div>
          {sourceName && (
            <span className="inline-block mt-2 text-xs px-2 py-0.5 rounded-full bg-[#14B8A6]/10 text-[#14B8A6]">
              {sourceName}
            </span>
          )}
        </div>

        <p className="text-xs text-[#94A3B8] mb-5 leading-relaxed">
          This content is hosted on <span className="text-[#F8FAFC]">{domain}</span>. 
          AI Know Board curates and indexes content from multiple platforms but does not control external sites.
        </p>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2.5 rounded-lg border border-white/10 text-sm text-[#94A3B8] hover:bg-white/[0.04] hover:text-[#F8FAFC] transition-colors"
            data-testid="external-link-cancel"
          >
            Stay Here
          </button>
          <button
            onClick={handleContinue}
            className="flex-1 px-4 py-2.5 rounded-lg bg-[#14B8A6] text-[#050B14] text-sm font-medium hover:bg-[#0D9488] transition-colors flex items-center justify-center gap-2"
            data-testid="external-link-continue"
          >
            Continue
            <ExternalLink className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
